import type {NzbPreview} from '@repo/shared/api/website_api';
import type {NzbsuVersion, TmdbVersion} from '@repo/shared/constant';
import type {Brand} from '@repo/shared/lib/type_utils';

export type UserId = Brand<'UserId', string>;

export interface UserItem {
  id: UserId;
  hash: string;
  salt: string;
  sessionDuration: number; // in seconds
}

interface NzbsuBaseItem {
  guid: string;
  title: string;
  size: number;
  pubTs: number;
  imdb: string;
  v: NzbsuVersion;
  nzb: string;
}

export type NzbsuRawItem = NzbsuBaseItem & Record<string, string>;

export enum NzbsuSearchSort {
  SizeDesc = 'size_desc',
  SizeAsc = 'size_asc',
  PostedDesc = 'posted_desc',
  PostedAsc = 'posted_asc',
  StatsDesc = 'stats_desc',
  StatsAsc = 'stats_asc',
}

//

export interface TmdbItem {
  imdb_id: string;
  v: TmdbVersion;
  firstPubTs: number;
  firstNzb: NzbPreview;
  lastNzb: NzbPreview;
  largestNzb: NzbPreview;
  lastUpdate: number;
  [key: string]: unknown;
}

export interface Tf1Video {
  videoId: string;
  kind: 'episode' | 'extra';
  listId: string;
  season: number | null;
  episode: number | null;
  part: number | null;
  title: string;
  broadcastAt: string | null;
  publishedAt: string | null;
  durationSeconds: number | null;
  url: string;
}

export interface Tf1Season {
  id: string;
  season: number | null;
  label: string;
  reportedVideoCount: number;
}

export type Tf1DownloadState = 'catalogued' | 'queued' | 'downloading' | 'complete' | 'blocked';

export interface Tf1VideoItem {
  pk: string;
  entity: 'video';
  video: Tf1Video;
  firstSeenAt: number; // Unix milliseconds
  lastSeenAt: number;
  state: Tf1DownloadState;
  attempts: number;
  workType?: 'FRESH' | 'BACKFILL';
  due?: number;
  owner?: string;
  leaseUntil?: number;
  objectKey?: string;
  bytes?: number;
  sha256?: string;
  completedAt?: number;
  errorCode?: string;
}

export interface Tf1SeasonItem {
  pk: string;
  entity: 'season';
  season: Tf1Season;
  firstSeenAt: number;
  lastSeenAt: number;
}

export interface Tf1ControlItem {
  pk: 'CONTROL';
  revision: number;
  owner?: string;
  purpose?: 'discovery' | 'download';
  leaseUntil?: number;
  cooldownUntil?: number;
  downloadStarts?: number[];
  discoveryCompletedAt?: number;
  discoveryVideoCount?: number;
  downloadsPaused?: boolean;
  pauseReason?: string;
}
